import React, { Component } from "react";
import numbro from 'numbro';

// OpenLayers
import OlMap from "ol/Map";
import OlView from "ol/View";
import OlCollection from "ol/Collection";
import OlFormatJSON from "ol/format/GeoJSON";

import OlStyle from 'ol/style/Style';
import OlStroke from 'ol/style/Stroke';
import OlFill from 'ol/style/Fill';
import OlRegularShape from 'ol/style/RegularShape';

import OlSourceTileWMS from "ol/source/TileWMS";
import OlSourceVector from "ol/source/Vector";
import OlSourceOSM from "ol/source/OSM";
import OlSourceRaster from "ol/source/Raster";
import OlSourceStamen from "ol/source/Stamen";

import OlLayerTile from "ol/layer/Tile";
import OlLayerVector from "ol/layer/Vector";
import OlLayerImage from "ol/layer/Image";

import { Zoom, Attribution, FullScreen, ScaleLine } from 'ol/control.js';

import { defaults as OlInteractionDefaults } from 'ol/interaction';

import proj4 from 'proj4';
import { register as OlRegister } from 'ol/proj/proj4'
import { get as OlGetProjection } from 'ol/proj'

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// import RotateNorthControl from './controls/RotateNorthControl.jsx';
import TopMenu from './TopMenu.jsx';
import BottomMenu from "./BottomMenu.jsx";
import SideContent from "./SideContent.jsx";

import { withNamespaces } from "react-i18next";

// @material-ui/core components
import Tooltip from '@material-ui/core/Tooltip';
import Icon from "@material-ui/core/Icon";
import IconButton from '@material-ui/core/IconButton';
import withStyles from "@material-ui/core/styles/withStyles";

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

import BaseLayerSwitcher from './controls/BaseLayerSwitcher';
import LayerSelector from "./controls/LayerSelector";
import BorderSelector from './controls/BorderSelector';
import SwipeTool from "./controls/SwipeTool.jsx";
import SwipeBar from "./controls/SwipeBar.jsx";
import MapScale from "./controls/MapScale.jsx";
import OverlaySwitcher from "./controls/OverlaySwitcher.jsx";
import ShowCoords from "./controls/ShowCoords.jsx";
import LayerInfo from "./controls/LayerInfo.jsx";
import LayerLegend from "./controls/LayerLegend.jsx";

import BaseLayerListFallback from "config/BaseLayerList.jsx";

import { geoserverService } from "services/geoserver";
import { API } from "services/api";

import { checkTrans } from 'helpers';

const url = process.env.REACT_APP_GeoServer_Url;

class PublicMap extends Component {
  constructor(props) {
    super(props);

    const { i18n, t, classes } = props;

    this.padding = 30;

    this.classes = classes;
    this.t = t;

    // state
    this.state = {
      map: undefined,
      viewResolution: 611.5,
      viewCenter: [456200, 5022012],
      projUnits: "m",
      zoom: 8,
      lng: i18n.language,
      overlays: [],
      selectedOverlayFeature: undefined,
      layers: [],
      baseLayers: this.getBaseLayers(),
      selectedBaseLayer: BaseLayerListFallback[0],
      selectedBorderLayer: undefined,
      selectedPrimaryLayer: undefined,
      primaryLayerOpacity: 1,
      primaryLayerName: undefined,
      selectedSecondaryLayer: undefined,
      secondaryLayerOpacity: 1,
      secondaryLayerName: undefined,
      height: 0,
      width: 0,
      swipetoolperc: 50,
      feature: undefined,

      pointerLeft: 0,
      pointerTop: 0,

      showPrimaryLayerInfo: false,
      showPrimaryLayerLegend: false,

      showFeatureInfo: false
    };

    this.userBaseLayers = [];
    this.systemBaseLayers = [];
    this.getBaseLayers = this.getBaseLayers.bind(this);
    this.setBaseLayer = this.setBaseLayer.bind(this);
    this.addUserBaseLayer = this.addUserBaseLayer.bind(this);
    this.removeUserBaseLayer = this.removeUserBaseLayer.bind(this);
    this.getDefaultBaseLayer = this.getDefaultBaseLayer.bind(this);
    this.handleAddUserFeatures = this.handleAddUserFeatures.bind(this);
    this.handleRemoveUserFeatures = this.handleRemoveUserFeatures.bind(this);
    this.handleSelectUserFeature = this.handleSelectUserFeature.bind(this);
    this.setBorder = this.setBorder.bind(this);
    this.setPrimaryLayer = this.setPrimaryLayer.bind(this);
    this.setPrimaryLayerOpacity = this.setPrimaryLayerOpacity.bind(this);
    this.setPrimaryLayerVersion = this.setPrimaryLayerVersion.bind(this);
    this.setSecondaryLayer = this.setSecondaryLayer.bind(this);
    this.setSecondaryLayerOpacity = this.setSecondaryLayerOpacity.bind(this);
    this.setSecondaryLayerVersion = this.setSecondaryLayerVersion.bind(this);
    this.setMapScale = this.setMapScale.bind(this);
    this.handleSetSwipePosition = this.handleSetSwipePosition.bind(this);
    this.handleViewChange = this.handleViewChange.bind(this);
    this.togglePrimaryLayerInfo = this.togglePrimaryLayerInfo.bind(this);
    this.togglePrimaryLayerLegend = this.togglePrimaryLayerLegend.bind(this);
    this.toggleSecondaryLayerInfo = this.toggleSecondaryLayerInfo.bind(this);
    this.toggleSecondaryLayerLegend = this.toggleSecondaryLayerLegend.bind(this);
    this.handlePointerMove = this.handlePointerMove.bind(this);
    this.handleCloseFeatureInfo = this.handleCloseFeatureInfo.bind(this);
    this.closePrimarySideBar = this.closePrimarySideBar.bind(this);
    this.closeSecondarySideBar = this.closeSecondarySideBar.bind(this);

    //define proj
    proj4.defs("EPSG:3765", "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    OlRegister(proj4);
    this.htrs96 = OlGetProjection('EPSG:3765')
  }

  /* *** Base Layers *** */

  genBaseLayer(source, showgray) {
    if (showgray) {
      return new OlLayerImage({
        source: this.genGrayRaster(source),
        role: "base"
      });
    } else {
      return new OlLayerTile({
        source: source,
        role: "base"
      });
    }
  }

  genGrayRaster(source) {
    return new OlSourceRaster({
      sources: [source],
      operation: function (pixels) {
        var pixel = pixels[0];

        var red = pixel[0];
        var green = pixel[1];
        var blue = pixel[2];

        var v = (0.2126729 * red + 0.7151522 * green + 0.0721750 * blue);
        if (v === 0.0) {
          v = 255.0;
        }

        pixel[0] = pixel[1] = pixel[2] = v;
        pixel[3] = 255;

        return pixel;
      }
    })
  }

  geoServerLayer(url, layerName, opacity, role) {
    if (opacity === undefined || opacity === null) {
      opacity = 1;
    }
    return new OlLayerTile({
      opacity: opacity,
      source: new OlSourceTileWMS({
        params: {
          'LAYERS': layerName,
          'FORMAT': 'image/png'
        },
        url: url
      }),
      role: role
    })
  }

  loadBaseLayers() {
    this.systemBaseLayers = [];
    API.getBaseLayers()
      .then(data => {
        if (data && data.length > 0) {
          data.forEach(function (layer) {
            let d = {}
            d.id = layer.id;
            d.display = layer.title;
            d.displayCode = layer.title_trans_token;

            let source = undefined;
            switch (layer.type_title) {
              case 'TileWMS':
                source = new OlSourceTileWMS({
                  url: layer.url,
                  params: { 'LAYERS': layer.layer },
                  projection: layer.projection
                })
                break;
              case 'OSM':
                source = new OlSourceOSM();
                break;
              case 'Stamen':
                source = new OlSourceStamen({
                  layer: layer.layer
                })
                break;
              default:
                break;
            }

            d.layer = this.genBaseLayer(source, layer.showgray);

            this.systemBaseLayers.push(d);

          }.bind(this));
          this.setState({
            baseLayers: this.systemBaseLayers,
            selectedBaseLayer: this.systemBaseLayers[0]
          })
        }
      });
  }

  getBaseLayers() {
    let layers = [];
    layers.concat(this.systemBaseLayers);
    layers.concat(this.userBaseLayers);

    return layers;
  };

  setBaseLayer(baseLayer) {
    this.setState({
      selectedBaseLayer: baseLayer
    });
  };

  addUserBaseLayer(baseLayer) {
    // console.log('Map: addUserBaseLayer', baseLayer);
    this.userBaseLayers.push(baseLayer);
    this.setState({
      baseLayers: this.getBaseLayers()
    });
  };

  removeUserBaseLayer(baseLayer) {
    //console.log('Map: removeUserBaseLayer', baseLayer, this.userBaseLayers);
    this.userBaseLayers = this.userBaseLayers.filter(x => x.id !== baseLayer.id);
  };

  getDefaultBaseLayer() {
    if (this.systemBaseLayers && this.systemBaseLayers.length > 0) {
      return this.systemBaseLayers[0]
    }
  }

  /* **** Layers *** */

  loadLayers() {
    let layers = [];
    API.getLayers()
      .then(data => {
        if (data && data.length > 0) {

          let first = true;
          let currentGroup = -1;

          let defaultPrimaryLayerVersion = undefined;
          let defaultPrimaryLayerIsSet = false;
          let defaultSecondaryLayerVersion = undefined;
          let defaultSecondaryLayerIsSet = false;

          let type_data = data.reduce(function (result, current) {
            result[current['type_id']] = result[current['type_id']] || [];
            result[current['type_id']].push(current);
            return result;
          }, []);

          type_data.forEach(function (type) {

            type.forEach(function(layer) {
              if (layer.layer_defaultprimary === 1) {
                defaultPrimaryLayerVersion = layer.gs_layer;
              }
              if (layer.layer_defaultsecondary === 1) {
                defaultSecondaryLayerVersion = layer.gs_layer;
              }
            });

            if (type.length > 0) {

              if (type[0].group_id !== currentGroup) {
                if (first) {
                  first = false;
                } else {
                  layers.push({ divider: true });
                }
                layers.push({ header: true, displayCode: type[0].group_title_trans_token });
                currentGroup = type[0].group_id;
              }

              let d = {}
              let last = type.length - 1;

              d.displayCode = type[0].type_title_trans_token;
              d.showCode = type[0].type_showcode;
              d.years = type.map(x => { return x.layer_title; });
              d.layerNames = type.map(x => { return x.gs_layer; });
              d.layerName = type[last].gs_layer;
              d.layer = this.geoServerLayer(url, type[last].gs_layer, 0.8);
              d.desc = type[last].layer_desc;
              d.descCode = type[last].layer_desc_trans_token;
              d.dataCodeGroup = type[0].data_trans_token_group;

              layers.push(d);

              if (defaultPrimaryLayerVersion && !defaultPrimaryLayerIsSet) {
                this.setPrimaryLayer( d, defaultPrimaryLayerVersion);
                defaultPrimaryLayerIsSet = true;
              }

              if (defaultSecondaryLayerVersion && !defaultSecondaryLayerIsSet) {
                this.setSecondaryLayer( d, defaultSecondaryLayerVersion);
                defaultSecondaryLayerIsSet = true;
              }
            }
          }.bind(this));

          this.setState({
            layers: layers,
          })
        }
      });
  }

  /* *** Overlays - User Features *** */

  handleRemoveUserFeatures(param) {
    // console.log('Map: handleRemoveUserFeatures', param);
    let features = this.state.userFeaturesLayer.getSource().getFeatures();
    let newFeatures = features.filter(x => x.get('filename') != param.name);

    let olFeatureCollection = new OlCollection(newFeatures);

    this.state.userFeaturesLayer.setSource(
      new OlSourceVector({
        features: olFeatureCollection,
        featureProjection: this.htrs96
      })
    );

    this.setState(state => {
      let overlays = state.overlays.filter(x => x.name != param.name);
      state.userFeaturesLayer.setSource(
        new OlSourceVector({
          features: olFeatureCollection,
          featureProjection: this.htrs96
        })
      );
      return {
        overlays: overlays,
        userFeaturesLayer: state.userFeaturesLayer
      }
    });
  };

  handleAddUserFeatures(olNewFeatures, name) {
    // console.log('Map: handleAddUserFeatures', olNewFeatures, name);
    if (!olNewFeatures) {
      return;
    }

    olNewFeatures.forEach(function (f) {
      f.set('filename', name);
    });

    let olFeatureCollection = this.state.userFeaturesLayer.getSource().getFeaturesCollection()
    if (olFeatureCollection) {
      olFeatureCollection = olFeatureCollection.extend(olNewFeatures);
    } else {
      olFeatureCollection = new OlCollection(olNewFeatures);
    }

    var tmpVectorSource = new OlSourceVector({
      features: olNewFeatures,
      featureProjection: this.htrs96
    })

    this.map.getView().fit(tmpVectorSource.getExtent(), this.map.getSize());

    this.setState(state => {
      state.overlays.push({ name: name })
      state.userFeaturesLayer.setSource(
        new OlSourceVector({
          features: olFeatureCollection,
          featureProjection: this.htrs96
        })
      );
      return {
        overlays: state.overlays,
        userFeaturesLayer: state.userFeaturesLayer
      }
    });
  };

  handleSelectUserFeature(overlay) {
    // console.log('Map: handleSelectUserFeature', overlay);

    let olFeatures = this.state.userFeaturesLayer.getSource().getFeatures().filter(f => f.get('filename') == overlay.name);

    if (olFeatures.length > 0) {
      var tmpVectorSource = new OlSourceVector({
        features: olFeatures,
        featureProjection: this.htrs96
      })

      this.map.getView().fit(tmpVectorSource.getExtent(), this.map.getSize());
    }
  }

  /* *** Borders *** */

  setBorder(borderLayer) {
    this.setState({
      selectedBorderLayer: borderLayer
    });
  }

  /* *** Primary Layer *** */

  setPrimaryLayer(layer, layerName) {
    // console.log('Map: Primary layer ', layer);
    if (layer && layer.dataCodeGroup) {
      checkTrans(layer.dataCodeGroup);
    }

    this._setSelectedFeature(null, null);

    if (!layerName) {
      if (layer && layer.layerNames && layer.layerNames.length > 0) {
        let last = layer.layerNames.length - 1;
        layerName = layer.layerNames[last];
      }
    }

    this.setState({
      selectedPrimaryLayer: layer,
      primaryLayerName: layerName,
    });
  }

  setPrimaryLayerOpacity(value) {
    this.setState({
      primaryLayerOpacity: value
    });
  }

  setPrimaryLayerVersion(value) {
    this.setState({
      primaryLayerName: value
    });
  }

  /* *** Secondary Layer *** */
  setSecondaryLayer(layer, layerName) {
    if (layer && layer.dataCodeGroup) {
      checkTrans(layer.dataCodeGroup);
    }

    this._setSelectedFeature(null, null);

    if (!layerName) {
      if (layer && layer.layerNames && layer.layerNames.length > 0) {
        let last = layer.layerNames.length - 1;
        layerName = layer.layerNames[last];
      }
    }

    this.setState({
      selectedSecondaryLayer: layer,
      secondaryLayerName: layerName,
      feature: null
    });
  }

  setSecondaryLayerOpacity(value) {
    this.setState({
      secondaryLayerOpacity: value
    });
  }

  setSecondaryLayerVersion(value) {
    this.setState({
      secondaryLayerName: value
    });
  }

  togglePrimaryLayerInfo() {
    this.setState(state => ({ showPrimaryLayerInfo: !state.showPrimaryLayerInfo }));
  }

  togglePrimaryLayerLegend() {
    this.setState(state => ({ showPrimaryLayerLegend: !state.showPrimaryLayerLegend }));
  }

  closePrimarySideBar() {
    this.setState({
      showPrimaryLayerInfo: false,
      showPrimaryLayerLegend: false
    });
  }

  toggleSecondaryLayerInfo() {
    this.setState(state => ({ showSecondaryLayerInfo: !state.showSecondaryLayerInfo }));
  }

  toggleSecondaryLayerLegend() {
    this.setState(state => ({ showSecondaryLayerLegend: !state.showSecondaryLayerLegend }));
  }

  closeSecondarySideBar() {
    this.setState({
      showSecondaryLayerInfo: false,
      showSecondaryLayerLegend: false
    });
  }

  findLayer(layers, role) {
    let layer = null;
    let index = null;
    layers.forEach((el, ind, arr) => {
      if (el.get('role') === role) {
        index = ind;
      }
    });
    if (index) {
      layer = layers.item(index);
    }
    return layer;
  }

  refreshLayers(chBase, chPrim, chPrimOp, chSecond, chSecondOp, chBorder) {
    var layers = this.map.getLayers();
    if (chBase) {
      let baseLayer = this.state.selectedBaseLayer.layer
      layers.setAt(0, baseLayer);
    }

    if (chPrim) {
      let currentPrimary = this.findLayer(layers, "primary");

      if (this.state.selectedPrimaryLayer) {
        layers.insertAt(1, this.geoServerLayer(url, this.state.primaryLayerName, this.state.primaryLayerOpacity, "primary"));
      }

      if (currentPrimary) {
        layers.remove(currentPrimary);
      }
    }
    else if (chPrimOp) {
      let currentPrimary = this.findLayer(layers, "primary");
      currentPrimary.setOpacity(this.state.primaryLayerOpacity);
    }

    if (chSecond) {
      let currentSecondaryLayer = this.findLayer(layers, "secondary");
      if (currentSecondaryLayer) {
        layers.remove(currentSecondaryLayer);
      }

      if (this.state.selectedSecondaryLayer) {
        this.secondaryLayer = this.geoServerLayer(url, this.state.secondaryLayerName, this.state.secondaryLayerOpacity, "secondary");
        layers.insertAt(2, this.secondaryLayer);

        this.secondaryLayer.on('precompose', function (event) {
          var ctx = event.context;
          // slider handle width is 30px, handle left offset from window is 15px
          var leftOffset = (30 + 15) / 2;
          var width = ((ctx.canvas.width - (2 * this.padding)) * this.state.swipetoolperc / 100) + leftOffset;

          ctx.save();
          ctx.beginPath();
          ctx.rect(width, 0, ctx.canvas.width - width, ctx.canvas.height);
          ctx.clip();
        }.bind(this));

        this.secondaryLayer.on('postcompose', function (event) {
          var ctx = event.context;
          ctx.restore();
        });
      }
    } else if (chSecondOp) {
      let currentSecondaryLayer = this.findLayer(layers, "secondary");
      currentSecondaryLayer.setOpacity(this.state.secondaryLayerOpacity);
    }

    if (chBorder) {
      let currentBorderLayer = this.findLayer(layers, "border");
      if (currentBorderLayer) {
        layers.remove(currentBorderLayer);
      }
      if (this.state.selectedBorderLayer) {
        layers.push(this.state.selectedBorderLayer.layer);
      }
    }
  }

  refreshControls() {
    this.map.removeControl(this.controlZoom);
    this.controlZoom = new Zoom({ zoomInTipLabel: this.t("map:zoom-in"), zoomOutTipLabel: this.t("map:zoom-out") });
    this.map.addControl(this.controlZoom);

    this.map.removeControl(this.controlAttribution);
    this.controlAttribution = new Attribution({ collapsible: false, tipLabel: this.t("map:attributions") });
    this.map.addControl(this.controlAttribution);

    // this.map.removeControl(this.controlRotate);
    // this.controlRotate = new Rotate({tipLabel: this.t("map:rotate-reset")});
    // this.map.addControl(this.controlRotate);

    this.map.removeControl(this.controlScaleLine);
    this.map.addControl(this.controlScaleLine);

    // this.map.removeControl(this.controlFullScreen);
    // this.controlFullScreen = new FullScreen({tipLabel: this.t("map:full-screen")});
    // this.map.addControl(this.controlFullScreen);

  }

  componentDidMount() {
    //console.log("componentDidMount");

    const t = this.t;

    this.controlZoom = new Zoom({ zoomInTipLabel: t("map:zoom-in"), zoomOutTipLabel: t("map:zoom-out") });
    this.controlAttribution = new Attribution({ collapsible: false, tipLabel: t("map:attributions") });
    //this.controlRotate = new Rotate({tipLabel: t("map:rotate-reset")});
    this.controlFullScreen = new FullScreen({ tipLabel: t("map:full-screen") });
    this.controlScaleLine = new ScaleLine({});

    this.selectStyle = new OlStyle({
      stroke: new OlStroke({
        color: 'rgba(255,0,255,1)',
        width: 1
      }),
      fill: new OlFill({
        color: 'rgba(255,0,255,0.5)'
      })
    });

    this.userStyle = new OlStyle({
      stroke: new OlStroke({ color: 'rgba(254,0,0,1)', width: 2 }),
      fill: new OlFill({ color: 'rgba(254,0,0,0.1)' }),
      image: new OlRegularShape({
        fill: new OlFill({ color: 'rgba(254,0,0,0.9)' }),
        stroke: new OlStroke({ color: 'black', width: 2 }),
        points: 4,
        radius: 10,
        angle: Math.PI / 4
      })
    });

    let userFeaturesLayer = new OlLayerVector({
      source: new OlSourceVector({
        features: [],
        featureProjection: this.htrs96
      }),
      role: "user",
      style: this.userStyle
    });

    let selectedFeaturesLayer = new OlLayerVector({
      source: new OlSourceVector({
        features: [],
        featureProjection: this.htrs96
      }),
      role: "selected",
      style: this.selectStyle
    })

    this.view = new OlView({
      center: this.state.viewCenter,
      zoom: this.state.zoom,
      // extent: [1389685, 5200000, 2346662, 5973349],
      extent: [168615, 4687861, 847060, 5238175],
      projection: this.htrs96,
      minZoom: 8,
      maxZoom: 18
    });

    // create map object with layer
    this.map = new OlMap({
      interactions: OlInteractionDefaults({
        doubleClickZoom: false,
        altShiftDragRotate: false,
        pinchRotate: false
      }),
      // target: this.refs.mapContainer,
      controls: [this.controlZoom, this.controlAttribution],
      target: null,
      layers: [this.state.selectedBaseLayer.layer, selectedFeaturesLayer, userFeaturesLayer],
      view: this.view
    });

    this.map.setTarget(this.refs.mapContainer);

    this.map.on('click', this.handleMapClick.bind(this));

    this.map.on('pointermove', this.handlePointerMove);

    this.view.on('change', this.handleViewChange);

    this.view.on('change:resolution', function (e) {
      this.setState({
        zoom: e.target.getZoom(),
        viewResolution: e.target.getResolution(),
        projUnits: e.target.getProjection().getUnits()
      })
    }.bind(this));

    this.view.on('change:center', function (e) {
      this.setState({
        viewCenter: e.target.getCenter()
      })
    }.bind(this))

    window.addEventListener('resize', this.updateContainerSize.bind(this));

    //save map and layer references to local state
    this.setState({
      map: this.map,
      userFeaturesLayer: userFeaturesLayer,
      selectedFeaturesLayer: selectedFeaturesLayer,
      height: this.refs.mapContainer.clientHeight,
      width: this.refs.mapContainer.clientWidth
    })

    this.loadBaseLayers();
    this.loadLayers();
  }

  handlePointerMove(event) {
    this._setMouseCoords(event.coordinate);
  }

  _setMouseCoords(coordinates) {
    this.setState({
      mouseCoords: coordinates
    });
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.updateContainerSize.bind(this))
  }

  componentDidUpdate(prevProps, prevState) {
    const { i18n } = this.props;
    // console.log("componentDidUpdate", prevState, this.state);

    if (prevState.lng !== i18n.language) {
      this.setState({
        lng: i18n.language
      })
      this.refreshControls();
    }

    let chBase = this.isLayerObjectChanged(prevState.selectedBaseLayer, this.state.selectedBaseLayer);
    let chPrim = this.isLayerObjectChanged(prevState.selectedPrimaryLayer, this.state.selectedPrimaryLayer) || prevState.primaryLayerName !== this.state.primaryLayerName;
    let chPrimOp = prevState.primaryLayerOpacity !== this.state.primaryLayerOpacity;
    let chSecond = this.isLayerObjectChanged(prevState.selectedSecondaryLayer, this.state.selectedSecondaryLayer) || prevState.secondaryLayerName !== this.state.secondaryLayerName;
    let chSecondOp = prevState.secondaryLayerOpacity !== this.state.secondaryLayerOpacity;
    let chBorder = this.isLayerObjectChanged(prevState.selectedBorderLayer, this.state.selectedBorderLayer);

    let ch = chBase || chPrim || chPrimOp || chSecond || chSecondOp || chBorder;

    if (ch) {
      this.refreshLayers(chBase, chPrim, chPrimOp, chSecond, chSecondOp, chBorder);
    }
  }

  updateContainerSize() {
    if (this.refs.mapContainer) {
      this.setState({
        height: this.refs.mapContainer.clientHeight,
        width: this.refs.mapContainer.clientWidth
      });
    }
  }

  isLayerObjectChanged(a, b) {
    if (a === undefined && b === undefined) {
      return false;
    } else if (a && b && a.id === b.id && a.layerName === b.layerName) {
      return false;
    } else {
      return true;
    }
  }

  getQueryLayers() {
    let layers = [];
    if (this.state.selectedPrimaryLayer) {
      layers.push(this.state.selectedPrimaryLayer.layerName);
    }
    if (this.state.selectedSecondaryLayer) {
      layers.push(this.state.selectedSecondaryLayer.layerName);
    }

    return layers;
  }

  handleMapClick(event) {

    this._setMouseCoords(event.coordinate);

    // derive map coordinate (references map from Wrapper Component state) - EPSG:3857
    var clickedCoordinate = this.state.map.getCoordinateFromPixel(event.pixel);

    let queryLayers = this.getQueryLayers();
    let queryLayer = undefined;
    let queryLayerName = undefined;

    let pixel_x = event.pixel[0];
    let swipe_x = parseInt(this.state.swipetoolperc) / 100 * this.state.width;
    //console.log(pixel_x, swipe_x);

    if (pixel_x <= swipe_x) {
      queryLayer = this.state.selectedPrimaryLayer ? this.state.selectedPrimaryLayer : null;
      queryLayerName = this.state.selectedPrimaryLayer ? this.state.primaryLayerName : null;
    } else {
      if (this.state.selectedSecondaryLayer) {
        queryLayer = this.state.selectedSecondaryLayer;
        queryLayerName = this.state.secondaryLayerName;
      } else {
        queryLayer = this.state.selectedPrimaryLayer;
        queryLayerName = this.state.primaryLayerName;
      }
    }

    //console.log(queryLayer);

    if (queryLayers.length > 0) {
      this._setSelectedFeature(null);
      if (queryLayer && queryLayerName) {
        geoserverService.WMS.getFeatureInfo([queryLayerName], clickedCoordinate)
          .then(data => {
            if (data && data.features && data.features.length > 0) {
              let last = data.features.length - 1;

              let olFeatures = (new OlFormatJSON()).readFeatures(data);
              let olFeat = olFeatures[last];

              this._setSelectedFeature(olFeat, event.pixel, queryLayer);
            } else {
              this._setSelectedFeature(null);
            }

            this.refreshLayers();
          });
      }


    }
  }

  handleViewChange(event) {
    this._setSelectedFeature(null);
  }

  _setSelectedFeature(olFeat, clickPixelLocation, queryLayer) {
    if (olFeat) {
      let ns = queryLayer.dataCodeGroup;
      let showCode = queryLayer.showCode === "1";
      olFeat.setStyle(this.selectStyle);
      this.state.selectedFeaturesLayer.setSource(
        new OlSourceVector({
          features: [olFeat],
          featureProjection: this.htrs96
        })
      );

      let try_kod = olFeat.get("kod") || olFeat.get("kod_u") || olFeat.get("PALETTE_INDEX");
      let try_pov = olFeat.get('pov_ha_3') || olFeat.get('pov_ha') || olFeat.get('pov_1_ha');
      let try_ch = olFeat.get("kod_iz");

      let pov = null;
      if (try_pov) {
        pov = try_pov;
      }

      let dispCode = ns + ":" + try_kod;

      this.setState(() => {
        return {
          feature: olFeat,
          feature_code: try_kod,
          feature_showCode: showCode,
          feature_dispCode: dispCode,
          feature_change: try_ch,
          feature_area: pov,
          pointerLeft: clickPixelLocation[0],
          pointerTop: clickPixelLocation[1],
          showFeatureInfo: true
        }
      });

    } else {

      this.state.selectedFeaturesLayer.setSource(
        new OlSourceVector({
          features: [],
          featureProjection: this.htrs96
        })
      );

      this.setState({
        feature: null,
        showFeatureInfo: false
      });

    }
  }

  handleSetSwipePosition(value) {
    // console.log('Set swipe position ', value);
    this.setState({
      swipetoolperc: value
    });
    if (this.map) {
      this.map.render();
    }
  }

  setMapScale(res) {
    // console.log('Map Set Map Scale', res)
    if (res) {
      this.map.getView().setResolution(res);
    }
  }

  handleCloseFeatureInfo() {
    this._setSelectedFeature(null);
  }

  render() {
    const { t, classes } = this.props;

    return (
      <div ref="mapContainer" id="map" className={this.classes.mainMap} >
        <GridContainer className={classes.controlLayout}>
          <GridItem xs={2}>
            <SideContent
              left
              onClose={this.closePrimarySideBar}
            >
              {this.state.showPrimaryLayerInfo && this.state.selectedPrimaryLayer ?
                <LayerInfo
                  icon="help"
                  title="Info"
                  dispCode="map:info"
                  layer={this.state.selectedPrimaryLayer}
                />
                : null}
              {this.state.showPrimaryLayerLegend && this.state.selectedPrimaryLayer ?
                <LayerLegend
                  icon="grid_on"
                  title="Legend"
                  dispCode="map:legend"
                  layer={this.state.selectedPrimaryLayer}
                />
                : null}
            </SideContent>
          </GridItem>
          <GridItem xs={8}>
            <TopMenu>
              <LayerSelector
                title={t("map:cnt-select-layer-1")}
                layersList={this.state.layers}
                layer = {this.state.selectedPrimaryLayer}
                opacity={this.state.primaryLayerOpacity}
                version={this.state.primaryLayerName}
                onSelect={this.setPrimaryLayer}
                onSetOpacity={this.setPrimaryLayerOpacity}
                onSetYear={this.setPrimaryLayerVersion}
                onToggleLayerInfo={this.togglePrimaryLayerInfo}
                onToggleLayerLegend={this.togglePrimaryLayerLegend}
                xs={12}
                sm={6}
                md={4}
                lg={4}
              />

              <BorderSelector
                title={t("map:cnt-grouping")}
                onClick={this.setBorder}
                xs={12}
                sm={6}
                md={2}
                lg={2}
              />

              {/* <ModeSwitcher title={t("map:cnt-compare-type")} /> */}
              <LayerSelector
                title={t("map:cnt-select-layer-2")}
                layersList={this.state.layers}
                layer={this.state.selectedSecondaryLayer}
                opacity={this.state.secondaryLayerOpacity}
                version={this.state.secondaryLayerName}
                onSelect={this.setSecondaryLayer}
                onSetOpacity={this.setSecondaryLayerOpacity}
                onSetYear={this.setSecondaryLayerVersion}
                onToggleLayerInfo={this.toggleSecondaryLayerInfo}
                onToggleLayerLegend={this.toggleSecondaryLayerLegend}
                xs={12}
                sm={6}
                md={4}
                lg={4}
              />

              <BaseLayerSwitcher
                systemLayersList={this.systemBaseLayers}
                userLayersList={this.userBaseLayers}
                onSelect={this.setBaseLayer}
                onAdd={this.addUserBaseLayer}
                onRemove={this.removeUserBaseLayer}
                xs={12}
                sm={3}
                md={1}
                lg={1}
              />

              <OverlaySwitcher
                layersList={this.state.overlays}
                onRemove={this.handleRemoveUserFeatures}
                onAdd={this.handleAddUserFeatures}
                onSelect={this.handleSelectUserFeature}
                xs={12}
                sm={3}
                md={1}
                lg={1}
              />

            </TopMenu>
          </GridItem>
          <GridItem xs={2}>
            <SideContent
              right
              onClose={this.closeSecondarySideBar} >
              {this.state.showSecondaryLayerInfo && this.state.selectedSecondaryLayer ?
                <LayerInfo
                  icon="help"
                  title='Info'
                  dispCode="map:info"
                  layer={this.state.selectedSecondaryLayer}
                />
                : null}
              {this.state.showSecondaryLayerLegend && this.state.selectedSecondaryLayer ?
                <LayerLegend
                  icon="grid_on"
                  title='Legend'
                  dispCode="map:legend"
                  layer={this.state.selectedSecondaryLayer}
                />
                : null}
            </SideContent>
          </GridItem>
          <GridItem xs={12}>
            <BottomMenu>
              <MapScale
                zoom={this.state.zoom}
                projUnits={this.state.projUnits}
                viewResolution={this.state.viewResolution}
                onChangeScale={this.setMapScale}
              />
              <ShowCoords
                centerCoords={this.state.viewCenter}
                mouseCoords={this.state.mouseCoords}
              />
              {this.state.selectedSecondaryLayer ?
                <SwipeTool
                  fullWidth
                  hidden={this.state.selectedSecondaryLayer ? false : true}
                  onSetPosition={this.handleSetSwipePosition}
                  sliderPosition={this.state.swipetoolperc}
                />
                : null}
            </BottomMenu>
          </GridItem>
        </GridContainer>




        {this.state.selectedSecondaryLayer ?
          <SwipeBar
            id="swipe-tool"
            offsetPerc={parseInt(this.state.swipetoolperc, 10)}
            containerWidth={this.state.width}
          /> : null
        }

        {this.state.feature && this.state.showFeatureInfo ?
          <div ref="tooltip" id="tooltip" className={classes.simpleMapToolTip}
            style={{ display: "block", left: this.state.pointerLeft, top: this.state.pointerTop }}>
            <div className={classes.featureInfoCloseContainer}>
              <Tooltip title={t("common:close")} placement="top">
                <IconButton className={classes.featureInfoCloseButton} onClick={this.handleCloseFeatureInfo}>
                  <Icon className={classes.featureInfoCloseIcon}>clear</Icon>
                </IconButton>
              </Tooltip>
            </div>
            {this.state.feature_showCode ? t("map:code") + ": " + this.state.feature_code : null}
            {this.state.feature_showCode ? <br /> : null}
            {t(this.state.feature_dispCode)}<br />
            {this.state.feature_change ? t("map:last-state") + ": " + this.state.feature_change + " - " + t("clc:" + this.state.feature_change) : null}
            {this.state.feature_change ? <br /> : null}
            {this.state.feature_area ? t("map:area") + ": " + numbro(this.state.feature_area * 100).divide(100).format() + " ha" : null}
          </div>
          : null}

      </div>

    );
  }
}



// *** Drag & Drop functionality ***

//Drop Target Specification
// const dropTargetSpecifiction = {
//   drop(props, monitor, component) {
//     if (!component) {
//       return;
//     }
//     const item = monitor.getItem();
//     const delta = monitor.getDifferenceFromInitialOffset();
//     const left = Math.round(item.left + delta.x);

//     return {
//       dropLocation: {
//         x: left
//       }
//     };
//   }
// }

// Collecting function
// function collect(connect, monitor) {
//   return {
//     connectDropTarget: connect.dropTarget(),
//     isOver: monitor.isOver()
//   }
// }

export default withNamespaces()(withStyles(mapStyle)(PublicMap));

